<template>
    <!-- <div class="disclaimer">
  <strong>Disclaimer:</strong> The generated plans are not fully accurate as this system is still a work in progress.
  Updated and finalized plans will be available by <strong>February</strong>.
</div> -->
  <div class="container-fluid transfer two-to-four-year-transfer-container">

    <div class="page-title">
      <h2>Associate to Bachelor's Degree</h2>
      <div class="title-accent"></div>
      <p>Plan your complete pathway from community college to university</p>
    </div>

    <div class="form-card">
      <div class="form-grid">
        <div class="form-field" :class="{ 'is-filled': startingSchool, 'is-next': nextStep === 1 }">
          <div class="section-label">
            <span class="number-ring"><span class="section-number">01</span></span>
            <span>Starting School</span>
          </div>
          <SearchSelect class="school-selection-search" :items="startingSchools" :labelKey="'name'"
            :placeholder="startingSchool ? startingSchool.name : 'Search Schools'"
            @item-selected="onSelectStartingSchool" />
        </div>

        <div class="form-field" :class="{ 'is-filled': startingProgram, 'is-next': nextStep === 2 }">
          <div class="section-label">
            <span class="number-ring"><span class="section-number">02</span></span>
            <span>Starting Program</span>
          </div>
          <SearchSelect class="school-selection-search" :isLoading="isLoadingStartingPrograms"
            :items="startingSchoolPrograms" :labelKey="'display_name'"
            :placeholder="startingProgram ? (startingProgram.display_name || startingProgram.name) : 'Search Programs'"
            @item-selected="onSelectStartingProgram" />
        </div>

        <div class="form-field" :class="{ 'is-filled': destinationSchool, 'is-next': nextStep === 3 }">
          <div class="section-label">
            <span class="number-ring"><span class="section-number">03</span></span>
            <span>Destination School</span>
          </div>
          <SearchSelect class="school-selection-search" :items="destinationSchools" :labelKey="'name'"
            :placeholder="destinationSchool ? destinationSchool.name : 'Search Schools'"
            @item-selected="onSelectDestinationSchool" />
        </div>

        <div class="form-field" :class="{ 'is-filled': destinationProgram, 'is-next': nextStep === 4 }">
          <div class="section-label">
            <span class="number-ring"><span class="section-number">04</span></span>
            <span>Destination Program</span>
          </div>
          <SearchSelect class="school-selection-search" :isLoading="programsLoading" :items="destinationSchoolPrograms"
            :labelKey="'display_name'"
            :placeholder="destinationProgram ? (destinationProgram.display_name || destinationProgram.name) : 'Search Programs'"
            @item-selected="onSelectDestinationProgram" />
        </div>
      </div>

      <div class="text-center" style="margin-top: 32px;">
        <button class="ube-l-btn generate-btn" type="button" @click="onGenerate"
          :disabled="!startingSchool || !startingProgram || !destinationSchool || !destinationProgram || loading">
          Generate Transfer Plan
        </button>
      </div>
    </div>

    <!-- Names row -->
    <div v-if="transferReportLoaded" class="school-names">
      <span class="school-name" :class="{ set: !!startingSchool }">
        <i class="fa-solid fa-school"></i>
        <span v-if="startingSchool">{{ startingSchool.name }}</span>
        <span v-else>Starting School</span>
      </span>
      <i class="fa-solid fa-arrow-right"></i>
      <span class="school-name" :class="{ set: !!destinationSchool }">
        <i class="fa-solid fa-school"></i>
        <span v-if="destinationSchool">{{ destinationSchool.name }}</span>
        <span v-else>Destination School</span>
      </span>
    </div>

    <!-- Plan viz -->
    <div v-if="transferReportLoaded" class="row two-to-four-year-report-container">
      <div class="col-md-12 pl-0">
      <button v-if="userIsLoggedIn" @click="openPlanNameModal" class="btn btn-success mb-2 mr-2 ml-0"
        :disabled="planSaved || isSavingPlan">
          <span class="button-caption" v-if="isSavingPlan">Saving Plan ...</span>
          <span class="button-caption" v-else-if="planSaved">Plan Saved</span>
          <span class="button-caption" v-else>Save to my Plans</span>
        </button>

        <button data-toggle="modal" data-target="#reportSummarModal" class="btn btn-primary mb-2" type="button">
          Analyze transfer plan
        </button>
        
        <div class="transfer-notice-box">
          <strong>Note:</strong> The current plan assumes placement in Calculus I and English Composition I
        </div>
        
      </div>

<div class="col-md-12 dp-visualization-container p-4">
  <DegreePlanVisualization
    v-if="fourYearPlan && fourYearPlan.length"
    :planTermData="fourYearPlan"
    :isTransferPlan="true"
    :hadTransfer="true"
    :readOnly="true"
  />
</div>

<div class="col-md-12 p-0">
  <div class="pathway-disclaimer-box">
    <strong>Note:</strong>
    This plan represents one valid pathway to complete your degree. Alternative course selections or sequences may also satisfy degree requirements. Consult your academic advisor to review your options and develop the plan that best supports your academic goals.
  </div>
</div>
      
    </div>

      <div v-if="showPlanNameModal" class="plan-name-modal-backdrop" @click.self="closePlanNameModal">
        <div class="plan-name-modal">
          <h4>Name your plan</h4>
          <p class="plan-name-help">
            Choose a unique name so you can find this plan later.
          </p>

          <input
            id="planNameInput"
            v-model.trim="planNameInput"
            class="form-control"
            type="text"
            placeholder="Enter plan name"
            @input="planNameError = ''"
            @keyup.enter="confirmPlanNameAndSave"
          />

          <div v-if="planNameError" class="plan-name-error">
            {{ planNameError }}
          </div>

          <div class="plan-name-actions">
            <button class="btn btn-secondary" type="button" @click="closePlanNameModal">
              Cancel
            </button>

            <button
              class="btn btn-success"
              type="button"
              :disabled="isSavingPlan"
              @click="confirmPlanNameAndSave"
            >
              <span v-if="isSavingPlan">Saving...</span>
              <span v-else>Save Plan</span>
            </button>
          </div>
        </div>
      </div>

    <ReportSummaryModal :reportData="transferPlanAnalysis" />

    <LoadingState v-if="loading" :message="loadingMsg" :progress="loadingProgress" :steps="loadingSteps"
      :currentStep="currentLoadingStep" :patienceMessage="patienceMessage" />

    <ErrorState v-else-if="error" :message="errorMsg" :details="errorDetails" @reset="resetError" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, nextTick } from 'vue';
import SearchSelect from '@/components/SearchSelect.vue';
import ReportSummaryModal from '@/components/TransferSummaryModal.vue';
import LoadingState from '@/components/LoadingState.vue';
import ErrorState from '@/components/ErrorState.vue';
import type School from '@/models/school';
import type Program from '@/models/program';
import store from '@/store';
// @ts-ignore
import { DegreePlanVisualization } from '@unm-idi/vue-degree-plan/vue-degree-plan.js';

import { usePrograms } from '@/composables/usePrograms';
import { useLoadingError } from '@/composables/useLoadingError';
import { createTermObjects } from '@/utils/degreePlanUtils';
import { cleanPlanForSave, sanitizeUploadLabel } from '@/utils/planSerialization';
import { getSchools, generateTwoToFourPlan } from '@/services/apiService';

// ------------ auth ------------
const userIsLoggedIn = computed(() => store.state.userToken != null);

const nextStep = computed(() => {
  if (!startingSchool.value) return 1;
  if (!startingProgram.value) return 2;
  if (!destinationSchool.value) return 3;
  if (!destinationProgram.value) return 4;
  return 0;
});

// ------------ composables ------------
const {
  programs: destPrograms,
  isLoading: programsLoading,
  getProgramsFromLocalNdjson,
  getProgramRequirement: getProgramReq,
} = usePrograms();

const {
  loading, loadingMsg, loadingProgress, currentLoadingStep, loadingSteps, patienceMessage,
  error, errorMsg, errorDetails,
  startLoadingWithProgress, updateLoadingProgress, completeLoading, handleError, resetError,
} = useLoadingError();

// ------------ state ------------
const startingSchools = ref<School[]>([]);
const destinationSchools = ref<School[]>([]);

const startingSchool = ref<School | null>(null);
const destinationSchool = ref<School | null>(null);

const startingSchoolPrograms = ref<Program[]>([]);
const destinationSchoolPrograms = computed(() => {
  return destPrograms.value.map((p) => ({ ...p, disable: false }));
});

const startingProgram = ref<Program | null>(null);
const destinationProgram = ref<Program | null>(null);

const transferPlanAnalysis = ref<any>({});
const transferReportLoaded = ref(false);
const fourYearPlan = ref<any[]>([]);
const planSaved = ref(false);
const isSavingPlan = ref(false);

const showPlanNameModal = ref(false);
const planNameInput = ref("");
const planNameError = ref("");
// Only for this view:
const isLoadingStartingPrograms = ref(false);

// ------------ helpers ------------
// fetch programs for *any* school using university_layouts (used for starting school)
async function fetchProgramsForSchool(
  school: School,
  path = "/data/ActivePrograms.json"
): Promise<Program[]> {
  try {
    const response = await fetch(path);
    const text = await response.text();

    const colleges = text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .map((line) => JSON.parse(line));

    const disabledCodes = [''];

    const programs: Program[] = colleges.flatMap((college: any) =>
      (college?.Departments || []).flatMap((dept: any) =>
        (dept?.Programs || []).map((programStr: string) => {
          const match = programStr.match(/\((.*?)\)/);
          const code = match ? match[1] : '';

          const baseName = programStr.replace(/\s*\([^)]*\)\s*$/, '').trim(); 
          const parts = baseName.split(',').map(s => s.trim());

          let prettyDisplayName = baseName;
          if (parts.length >= 2) {
            const degree = parts[parts.length - 1];
            const major = parts.slice(0, -1).join(', ');
            prettyDisplayName = `${major} (${degree})`;
          }

          return {
            name: programStr,
            display_name: prettyDisplayName,
            code,
            disable: disabledCodes.includes(code),
          } as Program;
        })
      )
    );

    console.log("starting school programs:", programs);
    return programs;
  } catch (e: any) {
    throw new Error(
      `Failed to load local programs for ${school.name}: ${e.message || e}`
    );
  }
}

// Merge source/dest into a single four-year flow
function mergeDegreeplanIntoFourYear(sourceTerms: any[], destTerms: any[]): any[] {
  const taggedSource = (sourceTerms || []).map((t: any) => {
    const term = JSON.parse(JSON.stringify(t));
    term.school_role = "source";
    term.school_label = "Pima Community College";
    return term;
  });

  const taggedDest = (destTerms || []).map((t: any) => {
    const term = JSON.parse(JSON.stringify(t));
    term.school_role = "target";
    term.school_label = "University of Arizona";
    return term;
  });

  const combined = [...taggedSource, ...taggedDest].map((t, i) => {
    const term = JSON.parse(JSON.stringify(t));
    term.id = i;
    term.name = `Term ${i + 1}`;
    term.position = i;

    if (Array.isArray(term.plan_items)) {
      term.plan_items.forEach((pi: any) => {
        if (pi?.requirement) {
          pi.requirement.parent_id = i;
          pi.requirement.school_role = term.school_role;
          pi.requirement.school_label = term.school_label;
        }

        if (pi?.requirement?.course) {
          pi.requirement.course.school_role = term.school_role;
          pi.requirement.course.school_label = term.school_label;
        }

        if (pi?.requirement?.course?.academic_period) {
          const currentYear = new Date().getFullYear();
          pi.requirement.course.academic_period.id = i;
          pi.requirement.course.academic_period.term = term.name;
          pi.requirement.course.academic_period.code = `${currentYear}.${i}`;
          pi.requirement.course.academic_period.name = `${term.name} ${currentYear}`;
          pi.requirement.course.academic_period.academic_year = `${currentYear}-${currentYear + 1}`;
        }
      });
    }

    return term;
  });

  return combined;
}

// ------------ init ------------
(function init() {
  const { startingSchools: s, destinationSchools: d } = getSchools();
  startingSchools.value = s;
  destinationSchools.value = d;
})();

// ------------ actions ------------
async function onSelectStartingSchool(school: School) {
  try {
    resetError();
    transferReportLoaded.value = false;
    startingSchool.value = school;

    isLoadingStartingPrograms.value = true;
    startingSchoolPrograms.value = await fetchProgramsForSchool(
      school,
      "/data/pima-community-college/ActivePrograms.json"
    )  } catch (e: any) {
    handleError(e);
  } finally {
    isLoadingStartingPrograms.value = false;
  }
}

async function onSelectDestinationSchool(school: School) {
  try {
    resetError();
    transferReportLoaded.value = false;
    destinationSchool.value = school;
    await getProgramsFromLocalNdjson(school);
  } catch (e: any) {
    handleError(e);
  }
}

function onSelectStartingProgram(program: Program) {
  transferReportLoaded.value = false;
  startingProgram.value = program;
}

function onSelectDestinationProgram(program: Program) {
  transferReportLoaded.value = false;
  destinationProgram.value = program;
}

function splitEquivalencyCodes(value: any): string[] {
  if (!value) return [];
  return String(value)
    .split(",")
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean);
}

function buildSourceEquivalencyMap(sourceRaw: any[]) {
  const map = new Map<string, number>();

  (sourceRaw || []).forEach((course: any) => {
    const sourceId = Number(course?.id);
    if (!Number.isFinite(sourceId)) return;

    const eqCodes = splitEquivalencyCodes(course?.equivalency);
    eqCodes.forEach((eqCode) => {
      map.set(eqCode, sourceId);
    });
  });

  return map;
}

function remapOperandIdsByEquivalency(operand: any, sourceEquivToSourceId: Map<string, number>) {
  if (!operand) return;

  if (operand.type === "course" && operand.course) {
    const prereqCode = String(operand.course.code || "").trim().toUpperCase();
    const matchedSourceId = sourceEquivToSourceId.get(prereqCode);

    if (matchedSourceId != null) {
      operand.course.id = matchedSourceId;
    }
    return;
  }

  if (Array.isArray(operand.operands)) {
    operand.operands.forEach((child: any) =>
      remapOperandIdsByEquivalency(child, sourceEquivToSourceId)
    );
  }
}

function remapDestTermsUsingSourceEquivalencies(sourceRaw: any[], destTerms: any[]) {
  const clonedDestTerms = JSON.parse(JSON.stringify(destTerms));
  const sourceEquivToSourceId = buildSourceEquivalencyMap(sourceRaw);

  clonedDestTerms.forEach((term: any) => {
    (term.plan_items || []).forEach((pi: any) => {
      const course = pi?.requirement?.course;
      if (!course) return;

      if (course.prereq) {
        remapOperandIdsByEquivalency(course.prereq, sourceEquivToSourceId);
      }

      if (course.coreq) {
        remapOperandIdsByEquivalency(course.coreq, sourceEquivToSourceId);
      }
    });
  });

  return clonedDestTerms;
}

function getCourseCodeKey(value: any): string {
  const str = String(value ?? "").toUpperCase().trim();
  const m = str.match(/^[A-Z&]{2,6}\s*\d{1,4}[A-Z]{0,3}/);

  if (!m) return str;

  const raw = m[0].replace(/\s+/, " ").trim();
  return raw.replace(/^([A-Z&]{2,6})\s*(\d)/, "$1 $2");
}

function buildSourceRequirementMap(transferReport: any) {
  const map = new Map<string, string>();
  const rows = transferReport?.source_data?.source_data ?? [];

  rows.forEach((row: any) => {
    const code = getCourseCodeKey(row?.course ?? row?.code ?? row?.name ?? "");
    const requirement = String(row?.requirement ?? "").trim();

    if (code && requirement && !map.has(code)) {
      map.set(code, requirement);
    }
  });

  return map;
}

function attachSourceRequirementsToDegreePlan(sourceRaw: any[], transferReport: any) {
  const reqMap = buildSourceRequirementMap(transferReport);

  return (sourceRaw || []).map((course: any) => {
    const code = getCourseCodeKey(
      course?.code ??
      course?.full_name ??
      course?.name ??
      course?.course ??
      ""
    );

    const sourceRequirement =
      reqMap.get(code) ||
      course?.sourceRequirement ||
      course?.source_requirement ||
      course?.requirement ||
      "";

    return {
      ...course,
      sourceRequirement,
      source_requirement: sourceRequirement,
      requirement: sourceRequirement,
    };
  });
}
async function onGenerate() {
  
  if (!startingSchool.value || !destinationSchool.value || !startingProgram.value || !destinationProgram.value) return;

  startLoadingWithProgress();
  transferReportLoaded.value = false;
  planSaved.value = false;

  try {
    updateLoadingProgress(1, `Fetching requirements: ${destinationProgram.value.name}`);
    const destReq = await getProgramReq(destinationProgram.value);
    if (destReq && destinationProgram.value) {
      destinationProgram.value = { ...(destinationProgram.value as Program), requirements: destReq } as Program;

    }

    updateLoadingProgress(3, 'Generating two-to-four transfer plan...');
    const payload = {
      source_program: startingProgram.value,
      dest_program: destinationProgram.value,
    };

    const dataObj = await generateTwoToFourPlan(payload);
    updateLoadingProgress(5, 'Building degree plans...');
const sourceRaw = dataObj?.source_degreeplan || [];
const destRaw = dataObj?.destination_degreeplan || [];
const transferReport = dataObj?.transfer_plan_report || {};

const sourceRawWithRequirements = attachSourceRequirementsToDegreePlan(
  sourceRaw,
  transferReport
);

const sourceTerms = createTermObjects(sourceRawWithRequirements, 0, {
  includeSourceRequirement: true,
});

const sourceTermCount = sourceTerms.length;
const destTerms = createTermObjects(destRaw, sourceTermCount);

    const remappedDestTerms = remapDestTermsUsingSourceEquivalencies(sourceRaw, destTerms);

    fourYearPlan.value = mergeDegreeplanIntoFourYear(sourceTerms, remappedDestTerms);

transferPlanAnalysis.value = transferReport;
    transferReportLoaded.value = true;

    completeLoading();
  } catch (e: any) {
    handleError(e);
  }
}
function getDefaultPlanName() {
  const startName =
    startingProgram.value?.display_name ||
    startingProgram.value?.name ||
    "Starting Program";

  const destName =
    destinationProgram.value?.display_name ||
    destinationProgram.value?.name ||
    "Destination Program";

  return `${startName} → ${destName}`;
}

function getExistingPlanNames() {
  return new Set(
    store.state.degreePlans
      .map((p: any) => String(p?.name || "").trim().toLowerCase())
      .filter(Boolean)
  );
}

function openPlanNameModal() {
  planNameInput.value = getDefaultPlanName();
  planNameError.value = "";
  showPlanNameModal.value = true;

  nextTick(() => {
    document.getElementById("planNameInput")?.focus();
  });
}

function closePlanNameModal() {
  showPlanNameModal.value = false;
  planNameInput.value = "";
  planNameError.value = "";
}

async function confirmPlanNameAndSave() {
  const cleanName = planNameInput.value.trim();

  if (!cleanName) {
    planNameError.value = "Plan name is required.";
    return;
  }

  if (getExistingPlanNames().has(cleanName.toLowerCase())) {
    planNameError.value = "A plan with this name already exists. Please choose another name.";
    return;
  }

  await saveTransferPlan(cleanName);
  closePlanNameModal();
}
async function saveTransferPlan(planName: string) {
    try {
    isSavingPlan.value = true;
    const destSlug = sanitizeUploadLabel(destinationProgram.value?.name || 'Destination');
    const startSlug = sanitizeUploadLabel(startingProgram.value?.name || 'Source');
    const plan = {
      planType: 'twoToFour',
      s3Slug: { dest: destSlug, start: startSlug },
      name: planName,
      startingSchool: { name: startingSchool.value?.name },
      destinationSchool: { name: destinationSchool.value?.name },
      startingProgram: {
        name: startingProgram.value?.name,
        display_name: startingProgram.value?.display_name,
        code: startingProgram.value?.code,
      },
      destinationProgram: {
        name: destinationProgram.value?.name,
        display_name: destinationProgram.value?.display_name,
        code: destinationProgram.value?.code,
      },
      fourYearPlan: cleanPlanForSave(fourYearPlan.value),
      transferPlanAnalysis: transferPlanAnalysis.value,
    };
    await store.methods.uploadUserFile(
      plan,
      destSlug,
      startSlug,
      planName
    );
    planSaved.value = true;
  } catch (e: any) {
    handleError(e);
  } finally {
    isSavingPlan.value = false;
  }
}
</script>

<style>
.plan-name-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.plan-name-modal {
  width: 420px;
  max-width: 90vw;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
}

.plan-name-modal h4 {
  margin-bottom: 8px;
  color: #0a2e52;
  font-weight: 700;
}

.plan-name-help {
  color: #555;
  margin-bottom: 16px;
}

.plan-name-error {
  color: #dc2626;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
}

.plan-name-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.plan-term .term-head .term-title {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #00205B;
  letter-spacing: 0.02em;
}

.plan-saved {
  color: green;
}

.two-to-four-year-transfer-container .dp-visualization-container {
  position: relative;
}
.disclaimer{
  background:#fff3cd; 
  border:1px solid #ffeeba; color:#856404; 
  padding:12px 16px; 
  border-radius:8px; 
  font-family:Arial, Helvetica, sans-serif;
  text-align: center;
}

.two-to-four-year-transfer-container .dp-visualization-container .loc-divider {
  z-index: 1 !important;
}
.two-to-four-year-report-container .col-md-12.pl-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.transfer-notice-box {
  margin-top: 16px;
  padding: 14px 20px;
  background: #eef3f6;
  border: 1px solid #9fc2ff;
  color: #31485f;  
  border-radius: 6px;
  text-align: center;
  font-size: 15px;
  line-height: 1.5;
  width: 100%;
  display: block;
  box-sizing: border-box;
}
.pathway-disclaimer-box {
  margin-top: 16px;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #eef3f6;
  border: 1px solid #9fc2ff;
  color: #31485f;
  border-radius: 6px;
  text-align: center;
  font-size: 15px;
  line-height: 1.5;
  width: 100%;
  display: block;
  box-sizing: border-box;
}
</style>
